import { render, staticRenderFns } from "./root.view.vue?vue&type=template&id=5bf1aabd&scoped=true"
import script from "./root.view.vue?vue&type=script&lang=ts"
export * from "./root.view.vue?vue&type=script&lang=ts"
import style0 from "./root.view.vue?vue&type=style&index=0&id=5bf1aabd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf1aabd",
  null
  
)

export default component.exports